export interface BrowserCapabilities {
  pointerEvents: boolean;
  touchEvents: boolean;
  passiveEvents: boolean;
  cssTransforms: boolean;
  cssTransitions: boolean;
  requestAnimationFrame: boolean;
}

export class CompatibilityDetector {
	private static instance: CompatibilityDetector;
	private capabilities: BrowserCapabilities;
  
	private constructor() {
		this.capabilities = this.detectCapabilities();
	}
  
	static getInstance(): CompatibilityDetector {
		if (!CompatibilityDetector.instance) {
			CompatibilityDetector.instance = new CompatibilityDetector();
		}
		return CompatibilityDetector.instance;
	}
  
	getCapabilities(): BrowserCapabilities {
		return this.capabilities;
	}
  
	/**
   * Проверяет, поддерживается ли Pointer Events API
   */
	supportsPointerEvents(): boolean {
		return this.capabilities.pointerEvents;
	}
  
	/**
   * Проверяет, поддерживаются ли Touch Events
   */
	supportsTouchEvents(): boolean {
		return this.capabilities.touchEvents;
	}
  
	/**
   * Определяет оптимальную стратегию событий
   */
	getRecommendedEventStrategy(): 'pointer' | 'mouse-touch' {
		return this.capabilities.pointerEvents ? 'pointer' : 'mouse-touch';
	}
  
	/**
   * Проверяет, нужно ли использовать passive event listeners
   */
	shouldUsePassiveEvents(): boolean {
		return this.capabilities.passiveEvents;
	}
  
	private detectCapabilities(): BrowserCapabilities {
		return {
			pointerEvents: 'PointerEvent' in window,
			touchEvents: 'ontouchstart' in window || 
                  (navigator.maxTouchPoints !== undefined && navigator.maxTouchPoints > 0),
			passiveEvents: this.detectPassiveEventsSupport(),
			cssTransforms: this.detectCSSTransforms(),
			cssTransitions: this.detectCSSTransitions(),
			requestAnimationFrame: 'requestAnimationFrame' in window
		};
	}
  
	private detectPassiveEventsSupport(): boolean {
		let supportsPassive = false;
    
		try {
			const opts = Object.defineProperty({}, 'passive', {
				get: function() {
					supportsPassive = true;
					return true;
				}
			});
      
			window.addEventListener('test', () => {}, opts);
			window.removeEventListener('test', () => {});
		} catch (e) {
			// Если произошла ошибка, passive events не поддерживаются
		}
    
		return supportsPassive;
	}
  
	private detectCSSTransforms(): boolean {
		const style = document.createElement('div').style;
		return 'transform' in style || 'webkitTransform' in style || 'mozTransform' in style;
	}
  
	private detectCSSTransitions(): boolean {
		const style = document.createElement('div').style;
		return 'transition' in style || 'webkitTransition' in style || 'mozTransition' in style;
	}
}

